<div class="notification-wrapper">
  <div class="notifications">
    @for (notification of getNotifications().reverse(); track notification) {
      <his-simple-notification
        (closed)="hideNotification(notification)"
        [notification]="notification"></his-simple-notification>
    }
  </div>
</div>
@if (isNotificationButtonActive) {
  <div class="notificationcenter-button-wrapper" animate.enter="button-enter" animate.leave="button-leave">
    <button (click)="showAll()" class="notificationcenter-button icon" [title] = "'de.his.component.messages-infobox.restore.title' | hisUi"  hisImage="bell">
    </button>
    @if (isCounterVisible()) {
      <div [class.counter-bounce]="counterBounce" id="notification-counter" class="notification-counter">
        <span>{{countOfHiddenNotifications()}}</span>
      </div>
    }
  </div>
}
